import { IconPlay } from '../icons';
const CirclePlayIcon = () => {
  return <IconPlay className='absolute right-1/2 top-1/2 z-20 box-content h-6 w-6 -translate-y-1/2 translate-x-1/2 rounded-full bg-surface-scrim-white p-1 lg:h-11 lg:w-11 lg:p-2.5' data-sentry-element="IconPlay" data-sentry-component="CirclePlayIcon" data-sentry-source-file="circle-play-icon.tsx" />;
};
export default CirclePlayIcon;